if (!customElements.get('bd-room-hero')) {
  class BdRoomHero extends HTMLElement {
    connectedCallback() {
      this.scenes = [...this.querySelectorAll('[data-room-scene]')];
      this.choices = [...this.querySelectorAll('[data-room-choice]')];
      this.links = [...this.querySelectorAll('[data-room-link]')];
      this.motionButton = this.querySelector('[data-room-motion]');
      this.status = this.querySelector('[data-room-status]');
      if (!this.scenes.length) return;
      this.index = 0;
      this.request = 0;
      this.inView = true;
      this.userPaused = this.dataset.motion !== 'true';
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.events = new AbortController();
      const options = {signal: this.events.signal};
      this.choices.forEach((button, index) => button.addEventListener('click', () => {
        this.userPaused = true;
        this.show(index, true);
        this.updateMotion();
      }, options));
      this.motionButton.hidden = false;
      this.motionButton.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.updateMotion();
      }, options);
      this.addEventListener('focusin', () => this.updateMotion(), options);
      this.addEventListener('focusout', () => queueMicrotask(() => this.updateMotion()), options);
      document.addEventListener('visibilitychange', () => this.updateMotion(), options);
      this.reduced.addEventListener('change', () => this.updateMotion(), options);
      this.observer = new IntersectionObserver(([entry]) => {
        this.inView = entry.isIntersecting;
        this.updateMotion();
      }, {threshold: 0.1});
      this.observer.observe(this);
      this.updateMotion();
    }

    async show(index, announce = false) {
      const request = ++this.request;
      clearTimeout(this.timer);
      const scene = this.scenes[index];
      if (!scene) return;
      const template = scene.querySelector('template[data-room-media]');
      if (template) {
        scene.appendChild(template.content.cloneNode(true));
        template.remove();
      }
      const img = this.scenes[index].querySelector('img');
      if (img && !img.complete) {
        try { await img.decode(); } catch { this.updateMotion(); return; }
      }
      if (!this.isConnected || request !== this.request) return;
      if (img && !img.naturalWidth) { this.updateMotion(); return; }
      this.index = index;
      this.scenes.forEach((scene, i) => scene.classList.toggle('is-active', i === index));
      this.choices.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
      this.links.forEach((link, i) => { link.hidden = i !== index; });
      if (announce) this.status.textContent = this.links[index].textContent.trim();
      this.updateMotion();
    }

    updateMotion() {
      if (!this.isConnected || !this.motionButton) return;
      clearTimeout(this.timer);
      const paused = this.userPaused || this.reduced.matches;
      const active = !paused && this.inView && !document.hidden && !this.contains(document.activeElement);
      this.dataset.playing = String(active);
      this.dataset.paused = String(paused);
      this.motionButton.hidden = this.reduced.matches;
      this.motionButton.setAttribute('aria-label', paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      if (active && this.scenes.length > 1) this.timer = setTimeout(() => this.show((this.index + 1) % this.scenes.length), 9000);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.request += 1;
      this.events?.abort();
      this.observer?.disconnect();
    }
  }
  customElements.define('bd-room-hero', BdRoomHero);
}
